import { useMedia } from './use-media'

export function useDevice() {
  return useMedia<'desktop' | 'tablet' | 'mobile'>(
    ['(min-width: 1224px)', '(min-width: 768px)'],
    ['desktop', 'tablet'],
    'mobile'
  )
}
